import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { Input, Button, Space, Select } from 'antd'
import { validateEmail, validatePhone } from '../../assets/js/validators'
import { useCustomData } from '../../pages/context/loginCustomDataProvider';

interface LoginPageProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface loginInfo {
    loginName?: string;
    email?: string;
    phone?: string;
    password?: string;
    verification?: string;
    account?: string;
    emailError?: string;
    phoneError?: string;
    accountError?: string;
    passwordError?: string;
    verificationError?: string;
    enterAccount?: string;
    enterEmail?: string;
    enterPassword?: string;
    enterPasswordAgain?: string;
    enterVerification?: string;
    enterPhone?: string;
    forget?: string;
    getBack?: string;
    next?: string;
    check1?: string;
    verifyIdentity?: string;
    resetPassword?: string;
    orInfo?: string;
    backLogin?: string;
    seccond?: string;
    changeInfo?: string;
    sendVerification?:string;
    verifyIdentityFor?:string
}
const LoginPage: React.FC<LoginPageProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [activeIndex, setActiveIndex] = useState(0);
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [acount, setAcount] = useState('')
    const [error, setError] = useState<string | null | undefined>(null);
    const { getValue, customData } = useCustomData();

    const [loginInfo, setLoginInfo] = useState<loginInfo>({
        loginName: "",
        email: "",
        phone: "",
        password: "",
        verification: "",
        account: "",
        emailError: "",
        phoneError: "",
        accountError: "",
        passwordError: "",
        verificationError: "",
        enterAccount: "",
        enterEmail: "",
        enterPassword: "",
        enterPasswordAgain: "",
        enterVerification: "",
        enterPhone: "",
        forget: "",
        getBack: "",
        next: "",
        check1: "",
        verifyIdentity: "",
        resetPassword: "",
        orInfo: "",
        backLogin: "",
        seccond: "",
        changeInfo: "",
    });

    useEffect(() => {
        if (customData.length === 0) return; // 数据还没来
        const newLoginInfo: loginInfo = {
            loginName: getValue('loginName'),
            email: getValue('email'),
            phone: getValue('phone'),
            password: getValue('password'),
            verification: getValue('verification'),
            account: getValue('account'),
            emailError: getValue('emailError'),
            phoneError: getValue('phoneError'),
            accountError: getValue('accountError'),
            passwordError: getValue('passwordError'),
            verificationError: getValue('verificationError'),
            enterAccount: getValue('enterAccount'),
            enterEmail: getValue('enterEmail'),
            enterPassword: getValue('enterPassword'),
            enterPasswordAgain: getValue('enterPasswordAgain'),
            enterVerification: getValue('enterVerification'),
            enterPhone: getValue('enterPhone'),
            forget: getValue('forget'),
            getBack: getValue('getBack'),
            next: getValue('next'),
            check1: getValue('check1'),
            verifyIdentity: getValue('verifyIdentity'),
            resetPassword: getValue('resetPassword'),
            orInfo: getValue('orInfo'),
            backLogin: getValue('backLogin'),
            seccond: getValue('seccond'),
            changeInfo: getValue('changeInfo'),
        };
        setLoginInfo(newLoginInfo);
    }, [customData]);

    const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (activeIndex === 0) setEmail(value);
        else if (activeIndex === 1) setPhone(value);
        else setAcount(value);
        setError(null);
    };

    const toNext = () => {
        let isValid = true;
        let newError = null;

        switch (activeIndex) {
            case 0:
                if (!validateEmail(email)) {
                    isValid = false;
                    newError = loginInfo.emailError;
                }
                break;
            case 1:
                if (!validatePhone(phone)) {
                    isValid = false;
                    newError = loginInfo.phoneError;
                }
                break;
            case 2:
                if (acount.length < 3) {
                    isValid = false;
                    newError = loginInfo.accountError;
                }
                break;
        }

        if (!isValid) {
            setError(newError);
            return;
        }

        const payload = {
            [activeIndex === 0 ? 'email' : activeIndex === 1 ? 'phone' : 'acount']:
                activeIndex === 0 ? email : activeIndex === 1 ? phone : acount
        };

        handleViewChange(
            activeIndex === 0 ? 'emailVerification' :
                activeIndex === 1 ? 'phoneVerification' : 'accountLogin',
            payload
        );
    };

    const switchTab = [
        { switchname: loginInfo.email },
        { switchname: loginInfo.phone },
        { switchname: loginInfo.account },
    ];

    const options = [
        { value: '+86', label: '+86' },
        { value: '+72', label: '+72' },
    ];

    const isInputValid = () => {
        switch (activeIndex) {
            case 0: return email.trim() === '';
            case 1: return phone.trim() === '';
            case 2: return acount.trim() === '';
            default: return true;
        }
    };

    return (
        <div>
            <div className='login-header'>{loginInfo.loginName}</div>
            <div className='login-text'>
                {switchTab.map((item, index) => (
                    <span key={index} className='login-switch'
                        onClick={() => {
                            setActiveIndex(index);
                            setError(null);
                            setAcount('');
                            setEmail('');
                            setPhone('');
                        }}
                        style={{
                            color: index === activeIndex ? themeColor : 'inherit',
                            cursor: 'pointer'
                        }}>{item.switchname}</span>
                ))}
            </div>

            <div>
                {activeIndex === 0 && <Input placeholder={loginInfo.enterEmail} status={error ? 'error' : ''} value={email} onChange={inputChange}></Input>}
                {activeIndex === 1 && <Space.Compact>
                    <Select defaultValue="+86" options={options} />
                    <Input className='phoneInput' status={error ? 'error' : ''} value={phone} placeholder={loginInfo.enterPhone} onChange={inputChange} />
                </Space.Compact>}
                {activeIndex === 2 && <Input placeholder={loginInfo.enterAccount} status={error ? 'error' : ''} value={acount} onChange={inputChange}></Input>}
                {error && <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>{error}</div>}
            </div>

            <Button type="primary" onClick={toNext} disabled={isInputValid()}>
                {loginInfo.next}
            </Button>
        </div>
    );
};

export default LoginPage;
